import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import {
  FFGEnvironment,
  UnusedRoutesResponse,
  FfgSensitiveRoutesResponse,
  GatewayServicesResponse,
} from '@mercedes-benz/backstage-plugin-ffg-common';

export interface FfgApi {
  /**
   * Fetch unused routes for a specific environment
   *
   * @public
   */
  getUnusedRoutes(environment: FFGEnvironment): Promise<UnusedRoutesResponse>;

  /**
   * Fetch sensitive routes for a specific environment
   *
   * @public
   */
  getSensitiveRoutes(
    environment: FFGEnvironment,
  ): Promise<FfgSensitiveRoutesResponse>;

  /**
   * Fetch gateway services for a specific environment
   *
   * @public
   */
  getGatewayServices(
    environment: FFGEnvironment,
  ): Promise<GatewayServicesResponse>;
}

/**
 * ApiRef for the FfgApi.
 *
 * @public
 */
export const ffgApiRef: ApiRef<FfgApi> = createApiRef<FfgApi>({
  id: 'plugin.ffg.api',
});
